import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor() {}

  public getMonthName(time: number) {
    const monthNames = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(time);
    return monthNames[date.getMonth()];
  }

  public makeId() {
    var pt1 = Date.now().toString(16);
    var pt2 = this.getRandomInt(1000, 9999).toString(16);
    var pt3 = this.getRandomInt(1000, 9999).toString(16);
    return `${pt3}-${pt1}-${pt2}`.toUpperCase();
  }

  public getRandomInt(num1: number, num2: number) {
    var max = num1 >= num2 ? num1 + 1 : num2 + 1;
    var min = num1 <= num2 ? num1 : num2;
    return Math.floor(Math.random() * (max - min)) + min;
  }

  public getDaysBetweenDates(date1: Date, date2: Date) {
    const msBetween = Math.abs(date2.getTime() - date1.getTime());
    return msBetween / (60 * 60 * 24 * 1000);
  }

  clearNullValues = (values: any, criteria: Partial<IClearNullCriteria> = {}) => {
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        try {
          if (values[key] === null || values[key] === undefined) {
            delete values[key];
          }

          /**
           * should be ignored when values.tpe is BOOLEAN and key is defaultValue
           */
          if (criteria.clearFalse && values[key] === false && !(key === 'defaultValue' && values.tpe === 'BOOLEAN')) {
            delete values[key];
          }
          if (!criteria.skipArray && Array.isArray(values[key]) && values[key].length === 0) {
            delete values[key];
          }
          if (!criteria.skipString && typeof values[key] === 'string' && values[key].length === 0) {
            delete values[key];
          }
        } catch (error) {
          console.log(error);
        }
        if (typeof values[key] === 'object') {
          clearNullValues(values[key], criteria);
        }
        if (typeof values[key] === 'object' && !Array.isArray(values[key]) && isEmptyCustom(values[key])) {
          delete values[key];
        } else if (Array.isArray(values[key]) && values[key].every((value: any) => value === null)) {
          delete values[key];
        }
      }
    }
    return values;
  };
}

interface IClearNullCriteria {
  skipArray: boolean;
  skipString: boolean;
  clearFalse: boolean;
}

export const clearNullValues = (values: any, criteria: Partial<IClearNullCriteria> = {}) => {
  for (const key in values) {
    if (values.hasOwnProperty(key)) {
      try {
        if (values[key] === null || values[key] === undefined) {
          delete values[key];
        }

        /**
         * should be ignored when values.tpe is BOOLEAN and key is defaultValue
         */
        if (criteria.clearFalse && values[key] === false && !(key === 'defaultValue' && values.tpe === 'BOOLEAN')) {
          delete values[key];
        }
        if (!criteria.skipArray && Array.isArray(values[key]) && values[key].length === 0) {
          delete values[key];
        }
        if (!criteria.skipString && typeof values[key] === 'string' && values[key].length === 0) {
          delete values[key];
        }
      } catch (error) {
        console.log(error);
      }
      if (typeof values[key] === 'object') {
        clearNullValues(values[key], criteria);
      }
      if (typeof values[key] === 'object' && !Array.isArray(values[key]) && isEmptyCustom(values[key])) {
        delete values[key];
      } else if (Array.isArray(values[key]) && values[key].every((value: any) => value === null)) {
        delete values[key];
      }
    }
  }
  return values;
};

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
}

export function isEmptyCustom(obj: any) {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const editorConfig = {
  dialogsInBody: true,
  placeholder: '',
  tabsize: 2,
  height: '175px',
  toolbar: [
    ['misc', ['style', 'undo', 'redo']],
    ['style', ['bold', 'italic', 'underline']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['insert', ['link', 'hr']],
  ],
};
